import { useForm, UseFormProps } from 'react-hook-form';

const useFormMui = (props?: UseFormProps) => {
    const form = useForm(props);
    const { register: formRegister } = form;
    const register = (...args) => {
        const registerWithErrors = formRegister(...args);
        const erorr = form.formState.errors[args[0]];

        registerWithErrors.error = Boolean(erorr);
        registerWithErrors.helperText = erorr?.message;
        return registerWithErrors;
    };
    form.register = register;
    return form;
};

export default useFormMui;
